"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import VehicleVisitList from "./VehicleVisitList"
import VehicleVisitModal from "./VehicleVisitModal"
import VehicleEntryModal from "./VehicleEntryModal"
import VehicleVerificationModal from "./VehicleVerificationModal"
import type { VehicleVisit } from "./types"

const VehicleVisitContainer: React.FC = () => {
  const [detailsModalOpen, setDetailsModalOpen] = useState(false)
  const [entryModalOpen, setEntryModalOpen] = useState(false)
  const [verificationModalOpen, setVerificationModalOpen] = useState(false)
  const [selectedVisit, setSelectedVisit] = useState<VehicleVisit | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenDetails = (visit: VehicleVisit) => {
    setSelectedVisit(visit)
    setDetailsModalOpen(true)
  }

  const handleOpenEntry = () => {
    setEntryModalOpen(true)
  }

  const handleOpenVerification = () => {
    setVerificationModalOpen(true)
  }

  const handleSuccess = () => {
    setDetailsModalOpen(false)
    setEntryModalOpen(false)
    setVerificationModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Vehicle Visits" parent="Parking Management" />
      <Container fluid>
        <Row>
          <Col md="12">
            <VehicleVisitList
              onViewDetails={handleOpenDetails}
              onRecordEntry={handleOpenEntry}
              onVerifyVehicle={handleOpenVerification}
              refreshTrigger={refreshTrigger}
            />
          </Col>
        </Row>

        <VehicleVisitModal
          isOpen={detailsModalOpen}
          toggle={() => setDetailsModalOpen(false)}
          visitData={selectedVisit}
        />

        <VehicleEntryModal isOpen={entryModalOpen} toggle={() => setEntryModalOpen(false)} onSuccess={handleSuccess} />

        <VehicleVerificationModal
          isOpen={verificationModalOpen}
          toggle={() => setVerificationModalOpen(false)}
          onSuccess={handleSuccess}
        />
      </Container>
    </>
  )
}

export default VehicleVisitContainer
